<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Update Run</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <div class="md-layout">
                    <div class="md-layout-item no-grow filter-container">
                        <customer-options
                            :selected="run.runCustomerId"
                            :team-region-id="teamRegionId"
                            @selectedOption="handleCustomerChanged"
                        />
                    </div>
                    <div class="md-layout-item no-grow filter-container">
                        <charging-type-options
                            :selected-charge-type-id="run.runRateGroupId"
                            @selectedOption="handleRateTypeChanged"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click.stop="updateRun">Update</md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { ChargingTypeOptions } from '@/components';
import CustomerOptions from '@/pages/Trips/Components/CustomerOptions';

export default {
    name: 'UpdateRunModal',
    components: {
        ChargingTypeOptions,
        CustomerOptions
    },
    mixins: [GeneralMixin],
    props: {
        run: {
            type: Object,
            default: () => {}
        },
        teamRegionId: {
            type: Number,
            default: null
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            customerId: this.run.runCustomerId,
            customerName: this.run.runCustomerName,
            rateGroupId: this.run.runRateGroupId,
            rateGroupName: this.run.runRateGroupName
        };
    },
    methods: {
        handleCustomerChanged(customerId, customer) {
            if (!customer || customer === undefined) {
                this.customerName = null;
                this.customerId = null;
                return;
            }

            this.customerName = customer.name;
            this.customerId = !customerId ? null : customerId;
        },
        handleRateTypeChanged(rateRule) {
            if (!rateRule || rateRule === undefined) {
                this.rateGroupName = null;
                this.rateGroupId = null;
                return;
            }

            this.rateGroupName = rateRule.rateGroupName;
            this.rateGroupId = rateRule?.rateGroupId ?? null;
        },
        async updateRun() {
            try {
                const data = {
                    customerId: this.customerId,
                    rateGroupId: this.rateGroupId
                };

                this.$_handleLoaderState(true, 'UPDATING...');
                const api = `/api/runs/${this.run.runId}`;
                const payload = {
                    method: 'put',
                    data
                };

                await handleRequests(api, payload);
                this.$notify({
                    message: 'Successfully updated the run.',
                    type: 'success'
                });

                this.resolve({
                    code: 'ok',
                    runId: this.run.runId,
                    customerName: this.customerName,
                    rateGroupName: this.rateGroupName,
                    customerId: this.customerId,
                    rateGroupId: this.rateGroupId,
                    tripId: this.run.tripId
                });
            }
            catch(e) {
                const message = 'Could not update run.';
                showErrorMessage(this, message, e);
                this.resolve('error');
            }
            finally {
                this.$_handleLoaderState(false);
            }
        }
    }
}

</script>

<style lang="scss" scoped>
::v-deep .vs--searchable .vs__dropdown-toggle {
    border: none;
    padding-bottom: 5px;
    margin-top: 4px;
    background-color: transparent;
    cursor: pointer;
}


::v-deep .vs__selected-options {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-wrap: nowrap;
}

::v-deep .vs__search::placeholder {
    color: #aaaaaa;
    font-size: 14px;
}


.filter-container {
    max-width: 200px !important;
    flex: 0 0 auto !important;
}
</style>
